import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { affT } from "../lib/affI18n";

export default function AffiliateProgram() {
  const { locale } = useI18n();
  const A = affT(locale);
  return (
    <div data-testid="affiliate-program-public" style={{ maxWidth: 820, margin: "0 auto", padding: "56px 20px" }}>
      <Link to="/" style={{ color: "var(--pine, #075E62)", fontSize: 13, textDecoration: "none" }}>← Lura Finance</Link>
      <h1 style={{ fontSize: 40, lineHeight: 1.05, marginTop: 18, color: "var(--pine, #075E62)", fontFamily: "Newsreader, Georgia, serif" }}>{A.title}</h1>
      <p style={{ fontSize: 18, marginTop: 14, color: "#2C3B38", maxWidth: 680 }} data-testid="public-promise">{A.promise}</p>

      <h2 style={{ marginTop: 40, fontSize: 22, color: "var(--pine, #075E62)" }}>{A.pubHow}</h2>
      <ol style={{ marginTop: 12, display: "grid", gap: 10, paddingLeft: 20 }}>
        {A.pubSteps.map((s, i) => <li key={i} data-testid={`public-step-${i}`} style={{ fontSize: 15, color: "#2C3B38" }}>{s}</li>)}
      </ol>

      <h2 style={{ marginTop: 40, fontSize: 22, color: "var(--pine, #075E62)" }}>{A.rulesTitle}</h2>
      <ul style={{ marginTop: 12, display: "grid", gap: 8, paddingLeft: 20, listStyle: "disc" }}>
        {A.rules.map((r, i) => <li key={i} data-testid={`public-rule-${i}`} style={{ fontSize: 14.5, color: "#3A4844" }}>{r}</li>)}
      </ul>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 40 }}>
        <Link to="/register" data-testid="public-cta-register" style={{ background: "#075E62", color: "#F7FBFA", padding: "12px 22px", borderRadius: 999, fontWeight: 600, textDecoration: "none", fontSize: 14 }}>{A.pubCtaReg}</Link>
        <Link to="/login" data-testid="public-cta-login" style={{ border: "1px solid #D5E7E5", color: "#075E62", padding: "12px 22px", borderRadius: 999, fontWeight: 500, textDecoration: "none", fontSize: 14 }}>{A.pubCtaLogin}</Link>
      </div>
    </div>
  );
}
